import React, { useState, useEffect, useRef } from 'react'
import { isMobile, isAndroid, isIOS } from 'react-device-detect'
import ReactPlayer from 'react-player'
import { PhotoAlbum } from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import axios from 'axios'

import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import Card from 'react-bootstrap/Card'
import Carousel from 'react-bootstrap/Carousel'

import FloatingWhatsApp from 'react-floating-whatsapp'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import Wave from 'react-wavify'
import ParticlesBg from 'particles-bg'
import ReactFloaterJs from 'react-floaterjs'
import { ParallaxBanner } from 'react-scroll-parallax'
import Marquee from "react-marquee-slider"
import times from "lodash/times"
import { TypeAnimation } from 'react-type-animation'

import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp, FaPhoneAlt, FaEnvelope } from 'react-icons/fa'

import original from './img/eureka_logo_ws.png'
import logo from './img/eureka_alt_w.png'
import logo_start from './img/eureka_alt.png'
import logo_wa from './img/eureka_wa-logo-w.jpg'
import astro from './img/eureka_astro_1.webp'
import astro_2 from './img/eureka_astro_2.webp'
import astro_3 from './img/eureka_astro_3.webp'
import astro_4 from './img/eureka_astro_4.webp'
import astro_5 from './img/eureka_astro_5.webp'
import astro_6 from './img/portafolio.png'
import portafolio_web from './img/web-portafolio.png'
import done from './img/done.png'
import globo from './img/eureka_cohete.webp'

import redes from './img/eureka_redes.webp'
import design from './img/eureka_design.webp'
import learn from './img/eureka_learn.webp'
import web from './img/eureka_web.webp'
import photo from './img/eureka_photo.webp'
import clients from './img/eureka_clients.webp'
import video from './img/eureka_video.webp'
import ads from './img/eureka_ads.jpg'

//import 'animate.css';
import "animate.css/animate.min.css";
import "yet-another-react-lightbox/styles.css";
import './App.css';

import p01 from './img/portafolio/01.jpg'
import p02 from './img/portafolio/02.jpg'
import p03 from './img/portafolio/03.jpg'
import p04 from './img/portafolio/04.jpg'
import p05 from './img/portafolio/05.jpg'
import p06 from './img/portafolio/06.jpg'
import p07 from './img/portafolio/07.jpg'
import p08 from './img/portafolio/08.jpg'
import p09 from './img/portafolio/09.jpg'
import p10 from './img/portafolio/10.jpg'
import p11 from './img/portafolio/11.jpg'

const API_PATH = "https://digital-eureka.com/mailer.php";
const SITE_KEY = "6Le7o4UhAAAAAMtKSidIoVlcrI9n29WAI5ukwSfM";

const photos = [
  "https://digital-eureka.com/clients/client-1.webp",
  "https://digital-eureka.com/clients/client-2.webp",
];

function Portafolio() {
  const images = { logo, logo_start }
  const astros = [ astro, astro_2, astro_3, astro_4, astro_5 ]

  const [ naut, setNaut ] = useState('')
  const [facebookLink, setFacebookLink] = useState('https://www.facebook.com/SomosEureka')
  const [instagramLink, setInstagramLink] = useState('https://www.instagram.com/eureka_marketing/')
  const [tiktokLink, setTiktokLink] = useState('https://www.tiktok.com/@eurekamarketing')
  const [showMessage, setShowMessage] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [textBtn, setTextBtn] = useState('ENVIAR')
  const [showPrivacy, setShowPrivacy] = useState(false)
  const [showService, setShowService] = useState(false)
  const [service, setService] = useState(null)
  
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")

  const [ goingUp, setGoingUp ] = useState(false)
  const [ image, setImage ] = useState(images['logo'])
  const [lightIndex, setLightIndex] = useState(-1)

  const prevScrollY = useRef(0);
  const refHome = useRef(null);
  const refUs = useRef(null);
  const refServices = useRef(null);
  const refPromos = useRef(null);
  const refContact = useRef(null);
  const refGuest = useRef(null);
  const refFoto = useRef(null);

  const photosGallery = [
    { src: p01, width: 1900, height: 1943 },
    { src: p02, width: 1900, height: 1267 },
    { src: p03, width: 1200, height: 1800 },
    { src: p04, width: 1900, height: 2850 },
    { src: p05, width: 1900, height: 2533 },
    { src: p06, width: 1900, height: 2533 },
    { src: p07, width: 1900, height: 1520 },
    { src: p08, width: 1900, height: 1267 },
    { src: p09, width: 1900, height: 1267 },
    { src: p10, width: 1900, height: 2850 },
    { src: p11, width: 1900, height: 1520 }
  ]

  useEffect(() => {
    setNaut(astros[ Math.floor(Math.random() * astros.length) ])
    if ( isMobile ) {
      if( isAndroid ) {
        setFacebookLink('fb://page/1639569549659215')
      }
      else if( isIOS ) {
        setFacebookLink('fb://profile/1639569549659215')
      }
    }

    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
 
      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
 
      if (isScriptExist && callback) callback();
    }
 
    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });
  }, []);

  const showServiceContent = ( item ) => {
    setService(item)
    setShowService(true)
  }

  const handleNavClick = (eventKey) => {
    const yOffset = -100; 
    const element = eval(eventKey).current;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});
  }

  const handleOnClick = (e) => {
    e.preventDefault();
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
        handleOnSubmit(token);
      });
    });
  }

  const handleOnSubmit = (token) => {
    var form = document.getElementById('contactForm');
    var data = new FormData(form);
    data.append('recaptcha_response', token);

    setTextBtn("Enviando...")
    setIsActive(true)

    axios.post(API_PATH, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
    }).then(function(response) {

      if(response.data == "FAIL" || response.data == "ERROR") {
        setTextBtn("ENVIAR")
        setIsActive(false)

        setTitle("Error")
        setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
        setShowMessage(true)
      } else {
        setTextBtn("ENVIAR")
        setIsActive(false)

        setTitle("Mensaje enviado")
        setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
        setShowMessage(true)

        setName("");
        setPhone("");
        setEmail("");
        setComments("");
      }

    }).catch(function(err) {
      setTextBtn("ENVIAR")
      setIsActive(false) 

      setTitle("Error")
      setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
      setShowMessage(true)
    });
  }

  const handleCloseMessage = () => setShowMessage(false);

  return (
    <div className="App">
      <FloatingWhatsApp  
        className="wa-style"
        phoneNumber="5215655484513"
        accountName="Eureka!"
        statusMessage="En linea"
        avatar={logo_wa}
        chatMessage="Hola, ¡Bienvenido a Eureka! Nos alegra que nos escribas. Cuéntanos, ¿cómo podemos ayudarte?"
        allowClickAway
        notification={false}
      />

      <Modal show={showMessage} onHide={handleCloseMessage}>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{ title }</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{ message }</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button variant="secondary" onClick={handleCloseMessage}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showService} onHide={ () => setShowService(false) } aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton className="modal-service-header"></Modal.Header>
        <Modal.Body className="modal-service-body">
          <div><img loading='lazy' alt={ service != null ? service.title : '' } src={ service != null ? service.img : '' } className="modal-img" width="1000px" height="537px"/></div>
          <br/>
          <div className="modal-service-body-text">
            <div className="animate__animated animate__bounce animate__fadeIn section-title txt-center modal-title-style">{ service != null ? service.title : '' }</div>
            <br/>
            <div className="animate__animated animate__bounce animate__fadeIn animate__delay-1s service-desc txt-center">{ service != null ? service.desc : '' }</div>
          </div>
        </Modal.Body>
      </Modal>

      { !isMobile && 
        <Wave className='home-wave' fill='#fff' paused={false} options={{ height: isMobile ? 800 : 600, amplitude: 90, speed: 0.15, points: 2 }}></Wave>
      }
      <div className='home-bg'>
        <div className="home-style">
          <ParallaxBanner
              layers={[
                {
                    image: 'https://digital-eureka.com/eureka_galaxy_planets.webp',
                    speed: 15,
                    style: {
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'top',
                      //maxWidth: '1320px'
                    },
                },
              ]}
              style={{
                /*aspectRatio: '2 / 1',*/
              }}
          > 
          <Navbar id="ek-navbar" collapseOnSelect expand="lg" className="nav-bar-custom-start navbar-dark">
            <Container>
              <Navbar.Brand>
                <img loading='lazy' alt="Eureka!" id="brand_image" src={image} width="200px" height="71px" className="d-inline-block align-top brand-image-start"/>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse className="collapse-custom" id="responsive-navbar-nav">
                <Nav className="me-auto">
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
          <Container className="portfolio-section" style={{ position: "relative" }}>
            <div className="port-navspace"/>
            <Row className="align-items-center">
              <Col md ={ 12 }>
                { !isMobile && 
                  <TypeAnimation
                    sequence={[ 1000, 'PORTAFOLIO' ]}
                    speed={55}
                    wrapper="h2"
                    className="porfolio-title-big"
                    cursor={false}
                    repeat={0}
                  />
                }
                { isMobile &&
                  <div className="animate__animated animate__bounce animate__fadeIn animate__delay-1s home-title-big">PORTAFOLIO</div>
                }
              </Col>
              <Col md ={ 12 } align="center" className="port-height">
                {/*<img src={ home } className="eureka-img"/>*/}
                <div className="animate__animated animate__bounce animate__backInLeft animate__delay-1s">
                  <ReactFloaterJs>
                    <img alt="Eureka! Astronauta" src={ astro_6 } width="45%"/>
                  </ReactFloaterJs>
                </div>
              </Col>
            </Row>
          </Container>

          </ParallaxBanner>
        </div>
      </div>

      <br/><br/>
      <div>
        <div className="section" align="center">
          {/*<div className="item-content">*/}

          <div className="section-bg">
            
            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn animateOnce">
              <Container style={{ position: "relative" }} ref={ refServices }>
                <div className="section-title txt-center">
                  Manual de
                </div>
                <div className="port-section-title-row txt-center">
                  Identidad
                </div>
                <br/>
              </Container>
            </AnimationOnScroll>

          </div>

          <div className="section-bg">
            
            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn animateOnce">
              <Container style={{ position: "relative" }} ref={ refServices }>
                <Row className='align-items-center'>
                  <Col md={ 4 } style={{ display: 'unset' }}>
                    <div className="section-title txt-left">
                      Fotografía de
                    </div>
                    <div className="port-section-title txt-left">
                      pro
                    </div>
                    <div className="port-section-title txt-left">
                      duc
                    </div>
                    <div className="port-section-title txt-left">
                      to
                    </div>
                  </Col>
                  <Col md={ 8 }>
                    <PhotoAlbum className='bg-album' layout="columns" photos={ photosGallery } columns={ isMobile ? 2 : 3 } onClick={({ index }) => setLightIndex(index)}/>

                    <Lightbox
                      slides={ photosGallery }
                      open={lightIndex >= 0}
                      index={lightIndex}
                      close={() => setLightIndex(-1)}
                      // enable optional lightbox plugins
                      plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
                    />
                  </Col>
                </Row>
              </Container>
            </AnimationOnScroll>
            
          </div>
          <div className="port-navspace-alt"/>

          <div className="section-bg">
            
            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn animateOnce">
              <Container style={{ position: "relative" }}>
                <Row>
                  <Col md={ 12 } style={{ display: 'unset' }}>
                    <div className="port-section-title-row txt-center">
                      Páginas Web
                    </div>
                  </Col>
                </Row>
                <div className="port-navspace-alt"/>
                <Row>
                  <Col md={ 12 }>
                    <img alt="Web" src={ portafolio_web } width="100%"/>
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col md={ 4 }>
                    <div className='port-web-title' align="center"> <a href="https://avage.mx/" target='_blank'> Avage Química </a> </div>
                  </Col>
                  <Col md={ 4 }>
                    <div className='port-web-title' align="center"> <a href="https://digital-eureka.com/" target='_blank'> Eureka Digital </a> </div>
                  </Col>
                  <Col md={ 4 }>
                    <div className='port-web-title' align="center"> <a href="https://afirmativo.mx/" target='_blank'> Afirmativo </a> </div>
                  </Col>
                </Row>
              </Container>
            </AnimationOnScroll>
            
          </div>
          <div className="port-navspace-alt"/>

          <div className="section-bg sub-section-a">
            <ParticlesBg type="cobweb" color={ [ '#00a0f8' ] } bg={true}/>

            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn animateOnce">
              <Container style={{ position: "relative" }} ref={ refServices }>
                <Row className='align-items-center'>
                  <Col md={ 8 }>
                    <Container>
                      <Row className='align-items-center'>
                        <Col md={ 6 }>
                          <div align='center'>
                            <ReactPlayer width={ '60%' } url='/portafolio/r1.mp4' controls={ true }/>
                          </div> 
                        </Col>
                        <Col md={ 6 }>
                          <div><img alt="Web" src={ astro_3 } style={{ width: '70%' }}  /></div>
                        </Col>
                      </Row>
                      <Row className='align-items-center'>
                        <Col md={ 6 }>
                          <img alt="Web" src={ astro_5 } style={{ width: '70%' }}/>
                        </Col>
                        <Col md={ 6 }>
                          <div align='center'>
                            <ReactPlayer width={ '60%' } url='/portafolio/r2.mov' controls={ true }/>
                          </div> 
                        </Col>
                      </Row>
                    </Container>
                    
                  </Col>
                  <Col md={ 4 } style={{ display: 'unset' }}>
                    <div className="section-title txt-right">
                      Producción de
                    </div>
                    <div className="port-section-title txt-right">
                      Vi
                    </div>
                    <div className="port-section-title txt-right">
                      deo
                    </div>
                  </Col>
                </Row>
              </Container>
            </AnimationOnScroll>
            
          </div>

          <div className="sub-section-a">
          
            <div className="section-bg-box sub-section-b">
              <Container className="section-b">
                <Row className="align-items-center">
                  <Col md={ 6 }>
                    <ReactFloaterJs>
                      <img loading='lazy' alt="Contáctanos Eureka!" className="d-block w-100" src={ globo } width="1000px" height="1000px"/>
                    </ReactFloaterJs>
                  </Col>
                  <Col md={ 6 }>
                    <div className="contact-container" ref={ refContact }>
                      <div className="section-title txt-center" style={{ color: '#3bffff' }}>
                        Contacto
                      </div>
                      <Container>
                        <Row>
                          <Col md={ 12 } className="col-contact" onClick={ () =>  window.open("https://wa.me/5215621607472") }>
                            <FaWhatsapp className="contact-icons" />&nbsp;&nbsp;
                            <span className='contact-text'>56 2160 7472</span>
                          </Col>
                          <Col md={ 12 } className="col-contact" onClick={ () =>  window.open("mailto:info@digital-eureka.com") }>
                            <FaEnvelope className="contact-icons" />&nbsp;&nbsp;
                            <span className='contact-text'>info@digital-eureka.com</span>
                          </Col>
                        </Row>
                      </Container>
                      <br/>
                      <div style={{ color: '#fff' }}>¡Comencemos a impulsar tus ventas!</div>
                      <br/>
                      <div>
                        <Form id="contactForm" onSubmit={handleOnClick}>

                          <FloatingLabel label="Nombre completo" className="mb-3">
                            <Form.Control required name="name" value={name} onChange={ (e) => setName(e.target.value) } placeholder="-" />
                          </FloatingLabel>

                          <Form.Group className="mb-3">
                            <FloatingLabel label="Correo electrónico">
                              <Form.Control required type="email" value={email} name="email" onChange={ (e) => setEmail(e.target.value) } placeholder="-" />
                            </FloatingLabel>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <FloatingLabel label="Teléfono">
                              <Form.Control required type="number" value={phone} name="phone" onChange={ (e) => setPhone(e.target.value) } placeholder="-" />
                            </FloatingLabel>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <FloatingLabel label="Comentario">
                              <Form.Control required name="comments" as="textarea" value={comments} rows="3" className="textarea-style"  onChange={ (e) => setComments(e.target.value) } placeholder="-" />
                            </FloatingLabel>
                          </Form.Group>

                          <br/>
                          <div align="center">
                            <Button disabled={isActive} variant="outline-primary" type="submit">
                              <Spinner
                                className={isActive ? '' : 'hide'}
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                              { textBtn }
                            </Button>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
              <div className="pre-footer"></div>
            </div>   
          </div>

        </div>
      </div>

    </div>
  );
}

export default Portafolio;
